/*
Author : Raphaël Dardeau


Markup : 

<span data-timestamp="1418155432">9 déc 21h04</span>


Setup : 

$(function() {
	$(document).timestamp();
});
*/
;(function ( $, window, document, undefined ) {
    "use strict";

    var pluginName = "timestamp",
        defaults = {
			interval: 60,
			maxDeltaTimestamp: 86400 * 3
		};		

    function Plugin( element, options ) {
        this.element = element;
        this.settings = $.extend( {}, defaults, options) ;
        this._defaults = defaults;
        this._name = pluginName;
        this.init();
    }

    $.extend(Plugin.prototype, {

        init: function() {
			this.setElements();
			if (this.$elements.length) {
				this.setTime();
				this.interval = setInterval($.proxy(function() {
					this.setElements();
					this.setTime();
				}, this), this.settings.interval * 1000);
			}
		},
		
		setElements: function() {
			this.$elements = $("[data-timestamp]");
		},
		
		setTime: function() {
			var _this = this;
			if (this.$elements.length) {
				var currentTimestamp = Math.round(new Date().getTime() / 1000);
				this.$elements.each(function(i) {
					var itemTimestamp = $(this).data('timestamp');
					var deltaTimestamp = currentTimestamp - itemTimestamp;
					if (deltaTimestamp > 0)
						$(this).data("timestamp-text", $(this).text()).text(_this.getTimeStr(deltaTimestamp));
					if (deltaTimestamp > _this.settings.maxDeltaTimestamp)
						$(this).removeAttr('data-timestamp').text($(this).data("timestamp-text"));
				});
			} else
				clearInterval(_this.interval);
		},
		
		getTimeStr: function(timestamp) {
			var date = new Date(timestamp * 1000);
			var days = Math.floor(timestamp / 86400);
			var hours = date.getUTCHours();
			var minutes = date.getUTCMinutes();
			var seconds = date.getUTCSeconds();
			var timeStr = '';
			if (days)
				timeStr = "Il y a " + days + " jour" + this.getPlurial(days);
			else if (hours)
				timeStr = "Il y a " + hours + " heure" + this.getPlurial(hours);
			else if (minutes) 
				timeStr = "Il y a " + minutes + " minute" + this.getPlurial(minutes);
			else if (seconds) 
				timeStr = "A l'instant";
			return timeStr;
		},
		
		getPlurial: function(count) {
			return (count > 1) ? 's' : '';
		}
		
    });

    $.fn[ pluginName ] = function (options) {
        this.each(function() {
            if (!$.data(this, "plugin_" + pluginName)) {
                $.data(this, "plugin_" + pluginName, new Plugin(this, options));
            }
        });
        return this;
    };

})(jQuery, window, document);